/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ObjectResult } from '../../models/object-result';
import { UpsertUserCommand } from '../../models/upsert-user-command';

export interface ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params {
      body?: UpsertUserCommand
}

export function apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(http: HttpClient, rootUrl: string, params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
  const rb = new RequestBuilder(rootUrl, apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json;odata.metadata=minimal;odata.streaming=false');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=none;odata.streaming=false', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ObjectResult>;
    })
  );
}

apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse.PATH = '/api/upsert-user';
